import React from "react"
import classes from "./prices2.module.css"

const Prices2 = () => {
  return (
    <div className={classes.Prices2}>
      <h2>Price list</h2>
      <table>
        <tbody>
          <tr>
            <th>FACIALS</th>
          </tr>
          <tr>
            <td></td>
            <td>
              <strong>Face</strong>
            </td>
            <td>
              <strong>Face, neck and decolette</strong>
            </td>
          </tr>
          <tr>
            <td>
              Massage
              <br />
              <span className={classes.included}>included: </span>
              <i>serum, cream</i>
            </td>
            <td>£22</td>
            <td>£22</td>
          </tr>
          <tr>
            <td>
              Cleansing treatment
              <br />
              <span className={classes.included}>included: </span>
              <i>exfoliator, serum, mask, cream</i>
            </td>
            <td>£34</td>
            <td>£40</td>
          </tr>
          <tr>
            <td>
              Cleaning with cavitation peeling
              <br />
              <span className={classes.included}>included: </span>
              <i>exfoliator, serum, mask, cream</i>
            </td>
            <td>£46</td>
            <td>£56</td>
          </tr>
          <tr>
            <td>
              Cleaning with extraction
              <br />
              <span className={classes.included}>included: </span>
              <i>exfoliator, massage, serum, mask, cream</i>
            </td>
            <td>£50</td>
            <td>£62</td>
          </tr>
          <tr>
            <td>
              Microdermabrasion
              <br />
              <span className={classes.included}>included: </span>
              <i>enzymatic peeling, serum, algae mask, cream</i>
            </td>
            <td>£46</td>
            <td>£257</td>
          </tr>
          <tr>
            <td>
              Biolifting with microcurrents
              <br />
              <span className={classes.included}>included: </span>
              <i>exfoliator, ampoule, mask, cream</i>
            </td>
            <td>£48</td>
            <td>£58</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th>FREIHAUT FACIALS</th>
          </tr>
          <tr>
            <td></td>
            <td>
              <strong>Face</strong>
            </td>
            <td>
              <strong>Face, neck and decolette</strong>
            </td>
          </tr>
          <tr>
            <td>
              Hy+ - anti-ageing and moisturizing with hyaluronic acid with
              ultrasounds
              <br />
              <span className={classes.included}>included: </span>
              <i>acid peel, algae mask, serum, firming mask, cream</i>
            </td>
            <td>£50</td>
            <td>£50</td>
          </tr>
          <tr>
            <td>
              Citrus Care - antioxidant and radiance with ultrasounds
              <br />
              <span className={classes.included}>included: </span>
              <i>exfoliator, ampoule, mask, cream</i>
            </td>
            <td>£48</td>
            <td>£58</td>
          </tr>

          <tr>
            <td>
              OxygenO2 - regenerative and anti redness
              <br />
              <span className={classes.included}>included: </span>
              <i>tingle peeling, serum, mask, massage</i>
            </td>
            <td>£46</td>
            <td>£46</td>
          </tr>
          <tr>
            <td>
              White Tea - anti-ageing and anti wrinkle with needle free
              mesotherapy
              <br />
              <span className={classes.included}>included: </span>
              <i>exfoliator, serum, biocellulose mask, cream</i>
            </td>
            <td>£46</td>
            <td>£46</td>
          </tr>
          <tr>
            <td>
              The Active - rejuvenating and lifting with retinol
              <br />
              <span className={classes.included}>included: </span>
              <i>milky peel, massage, ampoule, sheet mask, cream</i>
            </td>
            <td>£48</td>
            <td>£48</td>
          </tr>
          <tr>
            <td>
              Even - whitening with chemical peel
              <br />
              <span className={classes.included}>included: </span>
              <i>acid peel, ampoule, sheet mask, cream</i>
            </td>
            <td>£42</td>
            <td>£42</td>
          </tr>
        </tbody>
      </table>
      <h5 style={{ color: "#12afa3" }}>
        * Ask for Freihaut treatments loyalty card!
      </h5>
      <table>
        <tbody>
          <tr>
            <th>PURLES FACIALS</th>
          </tr>
          <tr>
            <td></td>
            <td>
              <strong>Face</strong>
            </td>
            <td>
              <strong>Face, neck and decolette</strong>
            </td>
          </tr>
          <tr>
            <td>
              Pure Rebalancing - cleansing
              <br />
              <span className={classes.included}>included: </span>
              <i>gommage peeling, elixir, mask, cream</i>
            </td>
            <td>£36</td>
            <td>£45</td>
          </tr>
          <tr>
            <td>
              Sensi Skin Garden - calming
              <br />
              <span className={classes.included}>included: </span>
              <i>exfoliator, ampoule, mask, cream</i>
            </td>
            <td>£38</td>
            <td>£47</td>
          </tr>

          <tr>
            <td>
              Susi - anti-ageing and brightening
              <br />
              <span className={classes.included}>included: </span>
              <i>exfoliator, elixir, mousse mask, cream</i>
            </td>
            <td>£36</td>
            <td>£45</td>
          </tr>
          <tr>
            <td>
              Gold & Pearls - firming
              <br />
              <span className={classes.included}>included: </span>
              <i>exfoliator, elixir, algae mask, cream</i>
            </td>
            <td>£42</td>
            <td>£52</td>
          </tr>
          <tr>
            <td>
              DNA Detox vit.C - antioxidant
              <br />
              <span className={classes.included}>included: </span>
              <i>exfoliator, serum, algae mask, cream</i>
            </td>
            <td>£42</td>
            <td>£52</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th>PURLES DERMOCOSMETIC THERAPY</th>
          </tr>
          <tr>
            <td></td>
            <td>
              <strong>Face</strong>
            </td>
            <td>
              <strong>Face, neck and decolette</strong>
            </td>
          </tr>
          <tr>
            <td>
              HydraOxy Intense - anti-ageing and moisturizing
              <br />
              <span className={classes.included}>included: </span>
              <i>chemical peel, ampoule, biocellulose mask, cream</i>
            </td>
            <td>£48</td>
            <td>£60</td>
          </tr>
          <tr>
            <td>
              Clinical Repair - lifting and anti wrinkle
              <br />
              <span className={classes.included}>included: </span>
              <i>chemical peel, activator, patch mask, massage, cream</i>
            </td>
            <td>£48</td>
            <td>£60</td>
          </tr>

          <tr>
            <td>
              Redness Stop Sysytem - strengthening and soothing
              <br />
              <span className={classes.included}>included: </span>
              <i>chemical peel, ampoule, mask, cream</i>
            </td>
            <td>£42</td>
            <td>£52</td>
          </tr>
          <tr>
            <td>
              DNA Protection - anti-ageing and radiance
              <br />
              <span className={classes.included}>included: </span>
              <i>chemical peel, activator, massage, charcole mask, cream</i>
            </td>
            <td>£48</td>
            <td>£60</td>
          </tr>
          <tr>
            <td>
              Stem Cells - Rejuvenating and hydrating
              <br />
              <span className={classes.included}>included: </span>
              <i>chemical peel, serum, mousse mask, cream</i>
            </td>
            <td>£42</td>
            <td>£52</td>
          </tr>
          <tr>
            <td>
              Microneedling with firming, anti-ageing, anti-time or vit.C
              cocktail
              <br />
              <span className={classes.included}>included: </span>
              <i>acid peel, numb cream, cocktail, cream</i>
            </td>
            <td>£70</td>
            <td>£88</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th>CHEMICAL PEELS</th>
          </tr>
          <tr>
            <td></td>
            <td>
              <strong>Face</strong>
            </td>
            <td>
              <strong>Face, neck and decolette</strong>
            </td>
          </tr>
          <tr>
            <td>
              Acid Peels (glycolic, mandelic, pyruvic, ferulic,
              salicylic,lactobionic)
              <br />
              <span className={classes.included}>included: </span>
              <i>peel, serum, mask, cream with spf50</i>
            </td>
            <td>£42</td>
            <td>£52</td>
          </tr>
          <tr>
            <td>
              TCA 15% - medium depth peel
              <br />
              <span className={classes.included}>included: </span>
              <i>peel, serum, mask, cream with spf51</i>
            </td>
            <td>£50</td>
            <td>£62</td>
          </tr>

          <tr>
            <td>
              Retinol 4% - medium depth peel
              <br />
              <span className={classes.included}>included: </span>
              <i>vitamin complex, massage, retinol mask</i>
            </td>
            <td>£48</td>
            <td>£62</td>
          </tr>
          <tr>
            <td>
              Herbal Peel
              <br />
              <span className={classes.included}>included: </span>
              <i>concentrate, herbal blend with activator, oil</i>
            </td>
            <td>£60</td>
            <td>£75</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th>MESOTHERAPY</th>
          </tr>
          <tr>
            <td>
              Cocktail
              <br />
              <span className={classes.included}>included: </span>
              <i>acid peel, numb cream, cocktail, cream</i>
            </td>
            <td>From 70*</td>
          </tr>
          <tr>
            <td>
              Soft filler
              <br />
              <span className={classes.included}>included: </span>
              <i>acid peel, numb cream, soft filler, cream</i>
            </td>
            <td>From 120*</td>
          </tr>
          <tr>
            <td>
              Eye area with cocktail
              <br />
              <span className={classes.included}>included: </span>
              <i>radiance peel, numb cream, cream</i>
            </td>
            <td>From 50*</td>
          </tr>
          <tr>
            <td>
              Eye area with soft filler
              <br />
              <span className={classes.included}>included: </span>
              <i>acid peel, numb cream, soft filler, cream</i>
            </td>
            <td>From 110*</td>
          </tr>
          <tr>
            <td>
              Hands mesotherapy
              <br />
              <span className={classes.included}>included: </span>
              <i>acid peel, numb cream, soft filler, cream</i>
            </td>
            <td>From 110*</td>
          </tr>
          <tr>
            <td>
              Hair Grow Stimulation with cocktail
              <br />
              <span className={classes.included}>included: </span>
              <i>cocktail</i>
            </td>
            <td>From 60*</td>
          </tr>
          <tr>
            <td>
              Microneedling with Gen Factor for scarves
              <br />
              <span className={classes.included}>included: </span>
              <i>acid peel, numb cream, gen factor, cream</i>
            </td>
            <td>From 70*</td>
          </tr>
        </tbody>
      </table>
      <h5 style={{ color: "#12afa3" }}>
        *price depending on used product (Aquashine, Electri, Xela, BCN or
        other)
      </h5>
      <table>
        <tbody>
          <tr>
            <th>PLASMOTHERAPY PRP</th>
          </tr>
          <tr>
            <td>
              Vampire Face Lift
              <br />
              <span className={classes.included}>included: </span>
              <i>acid peel, numb cream, plasma, cream</i>
            </td>
            <td>£160</td>
          </tr>
          <tr>
            <td>
              Mesotherapy
              <br />
              <span className={classes.included}>included: </span>
              <i>acid peel, numb cream, plasma, cream</i>
            </td>
            <td>£160</td>
          </tr>
          <tr>
            <td>
              Hair Grow Stimulation
              <br />
              <span className={classes.included}>included: </span>
              <i>plasma</i>
            </td>
            <td>£140</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th>PERMANENT MAKE UP</th>
          </tr>
          <tr>
            <td>
              Eyebrow ombre/powdered/combination
              <br />
              <span className={classes.included}>included: </span>
              <i>Touch up included (up to 2 months)</i>
            </td>
            <td>£220</td>
          </tr>
          <tr>
            <td>
              Microblading
              <br />
              <span className={classes.included}>included: </span>
              <i>Refresh up to 12 months 50% off actual price</i>
            </td>
            <td>£190</td>
          </tr>
          <tr>
            <td>
              Upper or lower eyeliner
              <br />
              <span className={classes.included}>included: </span>
              <i>Refresh up to 18 months 70% off actual price</i>
            </td>
            <td>£120</td>
          </tr>
          <tr>
            <td>Lip liner with shading</td>
            <td>£180</td>
          </tr>
          <tr>
            <td>Full Lips</td>
            <td>£210</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th>BODY TREATMENTS</th>
          </tr>
          <tr>
            <td>
              Microneedling with lipolitic cocktail for strech marks
              <br />
              <span className={classes.included}>included: </span>
              <i>chemical peel, cocktail, cream</i>
            </td>
            <td>£60</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th>DERMAL FILLERS 1.1ML</th>
          </tr>
          <tr>
            <td>Lips</td>
            <td>£190</td>
          </tr>
          <tr>
            <td>Chin</td>
            <td>£180</td>
          </tr>
          <tr>
            <td>Cheeks</td>
            <td>£180</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th>DIODE LASER HAIR REMOVAL</th>
          </tr>
          <tr>
            <td>Upper lip/ Ears</td>
            <td>£24</td>
          </tr>
          <tr>
            <td>Side-whiskers/ Cheeks/ Chin</td>
            <td>£36</td>
          </tr>
          <tr>
            <td>Full face</td>
            <td>£80</td>
          </tr>
          <tr>
            <td>Back/ Front of the neck</td>
            <td>£36</td>
          </tr>
          <tr>
            <td>Nipples area/ Navel Line</td>
            <td>£30</td>
          </tr>
          <tr>
            <td>Abdomen</td>
            <td>£60</td>
          </tr>
          <tr>
            <td>Half arms</td>
            <td>£54</td>
          </tr>
          <tr>
            <td>Full arms</td>
            <td>£90</td>
          </tr>
          <tr>
            <td>Armpits</td>
            <td>£42</td>
          </tr>
          <tr>
            <td>Hands/ Feet</td>
            <td>£36</td>
          </tr>
          <tr>
            <td>Bikini line</td>
            <td>£48</td>
          </tr>
          <tr>
            <td>Extended bikini</td>
            <td>£60</td>
          </tr>
          <tr>
            <td>Brazilian bikini</td>
            <td>£72</td>
          </tr>
          <tr>
            <td>Hollywood bikini</td>
            <td>£90</td>
          </tr>
          <tr>
            <td>Butt crack</td>
            <td>£30</td>
          </tr>
          <tr>
            <td>Buttocks</td>
            <td>£60</td>
          </tr>
          <tr>
            <td>Half legs with knees</td>
            <td>£72</td>
          </tr>
          <tr>
            <td>Full legs</td>
            <td>£120</td>
          </tr>
          <tr>
            <td>Chest</td>
            <td>£84</td>
          </tr>
          <tr>
            <td>Lower/ Upper back</td>
            <td>£72</td>
          </tr>
          <tr>
            <td>Full back</td>
            <td>£114</td>
          </tr>
        </tbody>
      </table>
      <h5 style={{ color: "#12afa3" }}>
        When 4 subsequent procedures on 1 area are not sufficient, each next one
        50% off.
      </h5>
      <h5 style={{ color: "#12afa3" }}>IT IS CHEAPER IN A PACKAGE!</h5>
      <ul style={{ color: "tomato" }}>
        <li>- 15% off if bought for 2 or more areas during 1 visit</li>
        <li>
          - 20% off if you buy at least 4 following procedures on 1 area during
          1 visit
        </li>
      </ul>
      <h6 style={{ color: "#12afa3" }}>*deals don’t add up</h6>
      <table>
        <tbody>
          <tr>
            <th>WAXING</th>
          </tr>
          <tr>
            <td>Full legs</td>
            <td>£20</td>
          </tr>
          <tr>
            <td>Half legs</td>
            <td>£12</td>
          </tr>
          <tr>
            <td>Forearms</td>
            <td>£10</td>
          </tr>
          <tr>
            <td>Full arms</td>
            <td>£14</td>
          </tr>
          <tr>
            <td>Armpits</td>
            <td>£10</td>
          </tr>
          <tr>
            <td>Lip or chin</td>
            <td>£6</td>
          </tr>
          <tr>
            <td>Full face</td>
            <td>£18</td>
          </tr>
          <tr>
            <td>Bikini line</td>
            <td>£8</td>
          </tr>
          <tr>
            <td>Extended bikini</td>
            <td>£12</td>
          </tr>
          <tr>
            <td>Brazilian bikini</td>
            <td>£15</td>
          </tr>
          <tr>
            <td>Hollywood bikini</td>
            <td>£20</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th>EYES</th>
          </tr>
          <tr>
            <td>Eyebrow wax and shape</td>
            <td>£7</td>
          </tr>
          <tr>
            <td>Eyebrow tint</td>
            <td>£7</td>
          </tr>
          <tr>
            <td>Eyelash tint</td>
            <td>£9</td>
          </tr>
          <tr>
            <td>Eyelash, eyebrow tint and shape</td>
            <td>£20</td>
          </tr>
          <tr>
            <td>Brow Henna</td>
            <td>£18</td>
          </tr>
          <tr>
            <td>Lash Lift Treatment</td>
            <td>£28</td>
          </tr>
          <tr>
            <td>Lash Lift with tint</td>
            <td>£35</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default Prices2
